module.exports = __webpack_public_path__ + "static/media/lose.c11cc98f.gif";